import AppWrapper from "@/AppWrapper.vue"
import { createApp } from "vue"

export const app = createApp(AppWrapper)
